/// <amd-module name="Artifacts/Root/routing/Hooks" />
import { encodeName, encodeVersion } from "Artifacts/Root/helpers/PackageDecoderHelper";
import { feedHubRoute, packageDetails } from "Artifacts/Root/routing/Constants";
import { FeedResolvingService } from "Artifacts/Root/services/FeedResolvingService";
import * as React from "react";
import { generatePath, useParams } from "react-router-dom";
import { IVssPageContext } from "VSS/Platform/Context";
import { useComponentContext } from "VSS/Platform/Layout";

export function useDecodedURIParams<
  Params extends { [K in keyof Params]?: string } = {}
>(): Params {
  const params = useParams<Params>();
  Object.keys(params).forEach((key) => {
    if ((params as any)[key]) {
      (params as any)[key] = decodeURIComponent((params as any)[key]);
    }
  });
  return params;
}

export function useLegacyRedirection(): string | undefined {
  const { pageContext } = useComponentContext();
  const [redirectRoute, setRedirectRoute] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      //New UI such as badge Url uses query parameter(search length>0) too so need to check if _a exists for legacy redirect.
      if (window.location.search.length > 0 && params.get("_a")?.toLowerCase()) {
        switch (params.get("_a")?.toLowerCase()) {
          case "package": {
            // Having the version as "" causes generatePath()
            // to throw an exception.
            const packageVersion =
              encodeVersion(
                decodeURIComponent(params.get("version") || ""),
                params.get("protocolType") || "",
              ) || undefined;
            const packageName = encodeName(
              decodeURIComponent(params.get("package") || ""),
              params.get("protocolType") || "",
            );
            const feed = params.get("feed");
            const protocol =
              params.get("protocolType") ||
              (feed &&
                packageName &&
                (await getBadgePackageProtocol(pageContext, feed, packageName)));
            setRedirectRoute(
              generatePath(packageDetails, {
                feedIdentifier: feed || undefined,
                protocol: protocol || undefined,
                packageName: packageName,
                version: packageVersion,
              }),
            );
            break;
          }
          case "feed":
          case "settings":
          case "recyclebinpackage":
          case "recyclebin":
          default:
            setRedirectRoute(
              generatePath(feedHubRoute, { feedIdentifier: params.get("feed") || undefined }),
            );
            break;
        }
      }
    })();
  }, []);

  return redirectRoute;
}

export async function getBadgePackageProtocol(
  pageContext: IVssPageContext,
  feedId: string,
  packageId: string,
): Promise<string> {
  const feedResolvingService: FeedResolvingService = pageContext.getService(
    "IFeedResolvingService",
  );

  const feed = await feedResolvingService.getFeed(feedId, false);
  return feedResolvingService.getBadgePackageProtocol(feed.id, feed.project?.id, packageId);
}
